import React, { useState } from 'react'
import Modal from 'react-modal';
import Controller from '@components/Controller/index';
import Theme from '@components/Theme/index';
import { useRouter } from "next/router";
import { useSelector } from 'react-redux';
import { FourDotMenuIcon, FrodobotBikeMenuIcon, ReportIcon } from '@util/svgicon';
import * as actionTypes from '@redux/actionTypes';
import { useDispatch } from 'react-redux';
import { getParameterByName, getModeByUrl } from "@util/config";
import { rideTerminate } from '@services/api';
import { toast } from "react-toastify";
import toastErrorMessages from "@util/toastErrorMessage";
import { safeLocalStorage } from '@utils/localstorage';

const Menuitem = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const user = useSelector((state) => state?.setUserDetails?.user)
  const activeTheme = useSelector((state) => state.activeTheme)
  const createRide = useSelector((state) => state.missionDetail.createRide)
  const drivingBot = safeLocalStorage.getItem('drivingBot')
  const torunamentId = getParameterByName('tournamentId') || getParameterByName('tournamentid') || ''
  const tournamentData = safeLocalStorage.getItem('tournamentData')
  const testDriveRideId = useSelector((state) => state.testDriveDetails.testDriveRideId);
  const rideId = createRide?.id || testDriveRideId
  const [openModel, setOpenModel] = useState(false);
  const [themeModel, setThemeModel] = useState(false);

  const toggleOpen = () => {
    setOpenModel(true);
    dispatch({
      type: actionTypes.HIDE_MENU,
      payload: false
    })
  }

  const toggleOpenTheme = () => {
    setThemeModel(true);
    dispatch({
      type: actionTypes.HIDE_MENU,
      payload: false
    })
  }


  const toggleGoto = async () => {
    if (rideId) {
      await rideTerminate(rideId)
      toast.error(toastErrorMessages.rideTerminated, { position: "top-right" });
    }
    safeLocalStorage.removeItem(`ride_sequence_${drivingBot?.deviceId}`)
    safeLocalStorage.removeItem(`rideId_${drivingBot?.deviceId}`)
    safeLocalStorage.removeItem(`ride_${drivingBot?.deviceId}`)
    safeLocalStorage.removeItem(`sessionId_${drivingBot?.deviceId}`)
    safeLocalStorage.removeItem(`bot_status_${drivingBot?.deviceId}`)
    safeLocalStorage.removeItem(`location_${drivingBot?.deviceId}`)
    safeLocalStorage.removeItem(`tournamentId_${torunamentId}`)
    safeLocalStorage.removeItem(`agoratoken_${tournamentData?.deviceId}`)
    safeLocalStorage.removeItem(`keyBinding_${user?.id}`)
    safeLocalStorage.removeItem(`score_${user.id}`)
    safeLocalStorage.removeItem(`tournamentData`)
    safeLocalStorage.removeItem(`drivingBot`)
    safeLocalStorage.removeItem(`selectControllerName`)
    safeLocalStorage.removeItem(`keyboradKey`)
    safeLocalStorage.removeItem(`WheelKey`)
    safeLocalStorage.removeItem(`RemoteKey`)
    if (getModeByUrl() === 'playgame') {
      window.location.replace("/testdrive");
      // TODO: @franciscomasi To use Navigator we need to clean Redux properly
      // navigate("/testdrive");
    } else {
      window.location.replace("/dashboard");
      // TODO: @franciscomasi To use Navigator we need to clean Redux properly
      // navigate("/dashboard");
    }
  }

  const customStyles = {
    content: {
      top: '0%',
      right: '0%',
      left: '0%',
      bottom: '0%',
      borderRadius: '0%',
      border: '0%',
      padding: '0%',
      margin: '0%',
      opacity: '0.8',
      background: '#000000',
      width: '100%',
      height: '100%',
      backgroundImage: `url(${activeTheme.themeActive})`,
      backgroundSize: "100% 100%",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    },
  };


  const interComHandler = () => {
    if (window.Intercom) {
      window.Intercom('show')
    }
  }

  return (
    <div className="menu-panel">
      <div className="menu-panel-1">
        <div className="Frame">
          <FrodobotBikeMenuIcon />
        </div>
        <div className='Frodobots'>Frodobots</div>
        <div className='Immersive-drive'>Immersive Driving Experience - Menu</div>
        <div className='press-select'>
          <div className='press'>Press</div>
          <div className='square-dot'>
            <FourDotMenuIcon />
          </div>
          <div className='select'>to select</div>
        </div>
        <div className='Menu-lists'>
          <div className='Controller commen' onClick={toggleOpen}>Controller Settings</div>
          <div className='Theme commen' onClick={toggleOpenTheme}>Theme Settings</div>
          <div className='Quit-back commen' onClick={toggleGoto}>Quit and Abort Mission</div>
          <div className='report_letter' onClick={interComHandler}>
            <p className='report_issus_letter'>Report an issue</p>
            <ReportIcon />
          </div>
        </div>
      </div>
      <Modal
        isOpen={openModel}
        style={customStyles}
        ariaHideApp={false}
      >
        <Controller />
      </Modal>

      <Modal
        isOpen={themeModel}
        style={customStyles}
        ariaHideApp={false}
      >
        <Theme />
      </Modal>
    </div>
  )
}

export default Menuitem;



